import { useEffect, useState } from "react";
import { pubSub } from "../ably";

// Viewers currently on this session: live Ably presence minus the admin, the same
// source the Users modal uses. Refreshes on presence and connection changes.
export default function useTotalUsers() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const refresh = () => {
      pubSub
        .getPresenceMembers()
        .then((list) => {
          if (cancelled) return;
          const viewers = (list || []).filter((m) => m.userId && m.userId !== "admin");
          setCount(viewers.length);
        })
        .catch((e) => {
          if (!cancelled) setCount(0);
          console.warn("[useTotalUsers] presence read failed:", e?.message || e);
        });
    };
    refresh();
    const onConnectionChange = () => refresh();
    pubSub.onConnectionChange(onConnectionChange);
    pubSub.onPresenceChange(refresh);
    return () => {
      cancelled = true;
      pubSub.offConnectionChange(onConnectionChange);
      pubSub.offPresenceChange(refresh);
    };
  }, []);

  return count;
}
